<div class="w-100 h-100 display-flex align-items-center justify-content-end">
  <div class="float-right mr-3 d-flex justify-content-center align-items-center icon-lock-tendering-mode pointer-events-none pb-2">
    <i class="top-0 font-size-24 font-weight-semibold se-icon p-0 text-color-mandatory no-select">action_lock_on</i>
  </div>
</div>
